<template>
  <svg :class="svgClass" :style="svgStyle">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  },
  width: {
    type: String
  },
  height: {
    type: String
  }
})

const iconName = computed(() => `#icon-${props.name}`)
const svgClass = computed(() => {
  if (props.name) {
    return `svg-icon icon-${props.name}`
  }
  return 'svg-icon'
})
const svgStyle = computed(() => {
  let width = props.width === undefined ? undefined : props.width + 'px'
  let height = props.height === undefined ? undefined : props.height + 'px'
  return JSON.parse(
    JSON.stringify({
      width,
      height,
      color: props.color
    })
  )
})
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
}
</style>
